import React, { FC, ReactNode } from 'react';
import classNames from 'classnames';

import getClassName from 'src/common/utils/getClassName';
import styles from './CostBreakdown.module.scss';

type CostListProps = {
  children: ReactNode;
  variant?: 'multilevel' | 'offerSummary';
};

const CostList: FC<CostListProps> = ({
  children,
  variant,
}) => (
  <dl className={getClassName(styles, 'prices', classNames(variant))}>
    {children}
  </dl>
);

export const CostListLabel: FC<{ children: ReactNode }> = ({ children }) => (
  <dt className={styles.priceLabel}>
    {children}
  </dt>
);

export const CostListValue: FC<{
  children: ReactNode;
  priceId?: string;
}> = ({
  children,
  priceId,
}) => (
  <dd
    className={styles.priceValue}
    data-test={priceId}
  >
    {children}
  </dd>
);

export default CostList;
